import type { IconNode } from '../types';

/**
 * @name house-manor
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSA2VjJINXY0IiAvPgogIDxwYXRoIGQ9Ik0xOSA2VjJoLTR2NCIgLz4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHg9IjIiIHk9IjYiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0yIDEyaDQiIC8+CiAgPHBhdGggZD0iTTYgMjJWMTJsNS41LTYiIC8+CiAgPHBhdGggZD0ibTEyLjUgNiA1LjUgNnYxMCIgLz4KICA8cGF0aCBkPSJNMTggMTJoNCIgLz4KICA8cGF0aCBkPSJNMTIgMTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMCAyMnYtNWEyIDIgMCAxIDEgNCAwdjUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/house-manor
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const houseManor: IconNode = [
  ['path', { d: 'M9 6V2H5v4', key: '1mhbew' }],
  ['path', { d: 'M19 6V2h-4v4', key: '1ber94' }],
  ['rect', { width: '20', height: '16', x: '2', y: '6', rx: '2', key: 'prhqpe' }],
  ['path', { d: 'M2 12h4', key: 'j09sii' }],
  ['path', { d: 'M6 22V12l5.5-6', key: '85jqj1' }],
  ['path', { d: 'm12.5 6 5.5 6v10', key: '3vbp2u' }],
  ['path', { d: 'M18 12h4', key: 'wj9ykh' }],
  ['path', { d: 'M12 11h.01', key: 'z322tv' }],
  ['path', { d: 'M10 22v-5a2 2 0 1 1 4 0v5', key: '1raqyd' }],
];

export default houseManor;
